import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import IconClose from '@/shared/assets/icons/icon-close-wo-circle.svg';

import { ErrorNoticeStyled, ErrorNoticeContent } from './ErrorNotice.styled';

const ErrorNotice = ({ message, level, closable = true, afterClose, modifiers }) => {
  const [close, setClose] = useState(false);

  useEffect(() => {
    setClose(false);
  }, [message]);

  const handleClose = (status) => {
    setClose(status);
    afterClose();
  };

  return (
    !close && (
      <ErrorNoticeStyled level={level} modifiers={modifiers}>
        <ErrorNoticeContent role="alert">{message}</ErrorNoticeContent>
        {closable && <IconClose onClick={() => handleClose(true)} />}
      </ErrorNoticeStyled>
    )
  );
};

ErrorNotice.propTypes = {
  message: PropTypes.string,
  level: PropTypes.string,
  closable: PropTypes.bool,
  afterClose: PropTypes.func,
  modifiers: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

ErrorNotice.defaultProps = {
  message: 'Something wrong happened.',
  level: 'error',
  closable: true,
  afterClose: () => {},
  modifiers: '',
};

export default ErrorNotice;
